import AppState from '../AppState';
/**
 * Displays the Service Unavailable block.
 */
const getServiceUnavailable = () => {
    const addressConfirmed = AppState.get('addressConfirmed');
    const addressCheckProgress = AppState.get('addressCheckProgress');
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Window, context, settings } = drupalJsObjects;
    const { baseUrl } = settings;
    context.querySelector('#service-unavailable').style.display = 'block';
    const exitCheck = context.querySelector('#exit-address-check');
    exitCheck.onclick = (event) => {
        event.preventDefault();
        Window.location.href = `${baseUrl}/nbn-plans`;
    };
    context.querySelector('#address-confirmation-3').appendChild(addressConfirmed);
    if (addressCheckProgress) {
        addressCheckProgress.remove();
    }
    context.querySelector('#service-plans').style.display = 'none';
};
export default getServiceUnavailable;
